import axios from "axios";
import { handleResponse, handleError } from "./utils";
import { DOMAIN_AUTH } from "./constant";
import { IResponse } from "./interactionApi";

const ENDPOINT = DOMAIN_AUTH; // hoặc domain thật
interface AuthResponse {
  data?: {
    accessToken?: string;
  };
}
export const loginAdmin = async (email: string, password: string) => {
  try {
    const url = `${ENDPOINT}/login`;
    const payload = { userName: email, password };
    const response = await axios.post<IResponse<AuthResponse>>(url, payload);

    const { data } = handleResponse(response.data);

    console.log("login response", data?.accessToken);
    // Lưu token vào localStorage
    if (data?.accessToken) {
      localStorage.setItem("jwt", data?.accessToken);
    }

    return data;
  } catch (error) {
    return handleError(error, "login failed");
  }
};

export const logoutAdmin = () => {
  localStorage.removeItem("jwt");
};

export const getToken = () => {
  return localStorage.getItem("jwt");
};

export const isAuthenticated = () => {
  return !!getToken();
};
